module.exports = {
  billing_reconciliation: 'Reconciliation',
  billing_bill: 'Debit note Credit note',
  billing_accountStatement: 'Account Statement',
  billing_cancel: 'Cancel',
  billing_return: 'Return',
  billing_save: 'Save',
  billing_edit: 'Edit',
  billing_collectInvoice: 'Collect Invoice',
  billing_drawInvoice: 'Draw Invoice',
  billing_writeOff: 'Write-Off',
  billing_applyForPayment: '振込申請',
  billing_paymentBillState: 'Payment bill state',
  billing_print: 'Print',
  billing_adjustBillDate: 'Adjust 伝票日付',
  billing_addCharges: 'add fees and charges',
  billing_deleteCharges: 'remove fees and charges',
  billing_deleteAll: 'remove all',
  billing_viewDeleteAll: 'View/Delete charge detail',
  billing_newAdjustment: 'New Adjustment',
  billing_editAdjustment: 'Edit Adjustment',
  billing_deleteAdjustment: 'removeAdjustment',
  billing_diffCharge: 'Handle discrepancies',
  billing_cancelConfirm: 'cancelConfirmation',
  billing_batchConfirm: 'batchConfirmation',
  billing_reconciliationAmount: '精算差額金額',
  billing_exchangeRate: '為替レート',
  // billing_bill: 'Debit note/Credit note',
  billing_charges: 'feesandcharges',
  billing_business: 'Business',
  billing_recheck: '再確認',
  billing_cancelRecheck: '再確認撤回',
  billing_recheckTip: 'Please confirm the bill before reviewing it',
  billing_recheckStatus: 'Billing review status',
  billing_reviewPeople: 'Billing review people',
  billing_reviewDate: 'Billing review date',
  billingView_Determine: 'OK',
  billingView_Close: '閉じる',
  includeAdjustmentCharge: '調整費用を含めますか',
  chargeList_query: 'Query',
  chargeList_newBill: 'New Bill',
  chargeList_startReconciliation: 'Start Reconciliation',
  chargeList_drawCollectInvoice: 'Draw/Collect Invoice',
  chargeList_writeOff: 'Write-Off',
  chargeList_applyForPayment: 'Request Withdrawal',
  chargeList_submission: 'Submit',
  chargeList_cancelSubmit: 'Cancel Submit',
  chargeList_revenueAndExpenditureMethod: '収支方式',
  chargeList_invoiceRevenueAndExpenditureMethod: 'Invoice 収支方式',
  chargeList_receivables: 'Receivables',
  chargeList_payables: 'Payables',
  chargeList_all: 'All',
  chargeList_feeType: 'cost type',
  chargeList_domestic: 'Domestic',
  chargeList_international: 'Overseas',
  chargeList_reconciliationType: 'Reconciliation Type',
  chargeList_accordingToCharges: 'accordingto fees and charges',
  chargeList_accordingToBusiness: 'According To Business',
  chargeList_cancelReconciliation: 'Cancel Reconciliation',
  chargeList_saveReconciliation: 'Save Reconciliation',
  chargeList_newAdjustment: 'New Adjustment',
  chargeList_editAdjustment: 'Edit Adjustment',
  chargeList_deleteAdjustment: 'removeAdjustment',
  chargeList_diffCharge: 'Handle discrepancies',
  chargeList_cancelConfirm: 'cancelConfirmation',
  chargeList_batchConfirm: 'batchConfirmation',

  billingCharge_businessNumber: 'JobNumber',
  billingCharge_consignationCompany: 'Consignation Company',
  billingCharge_settlementCompany: 'Settlement Company',
  billingCharge_mblNo: 'MasterB/L',
  billingCharge_vessel: 'MotherVessel',
  billingCharge_voyage: 'VoyageNumber',
  billingCharge_carrier: 'Carrier',
  billingCharge_billNo: '請求番号',
  billingCharge_invoiceNo: 'インボイス番号',
  billingCharge_itemNo: 'ReferenceNumber',
  billingCharge_businessType: 'ShippingType',
  billingCharge_businessStatus: '配送ステータス',
  billingCharge_solicitationType: 'Source of Freight',
  billingCharge_chargeItem: 'Designation of charges',
  billingCharge_feeStatus: '支払ステータス',
  billingCharge_confirmStatus: '確認ステータス',
  billingCharge_businessDate: 'Job Date',
  billingCharge_amountRange: '金額帯',
  billingCharge_receivablesInvoicingDate: 'Receivables Invoicing Date',
  billingCharge_currency: ' 通貨',
  billingCharge_operation: ' 操作内容',
  billingCharge_sales: ' 売上',
  billingCharge_advanceMoneyForAnotherOrNot: 'disbursement or not',
  billingCharge_adjustedOrNot: 'adjust or not',
  billingCharge_wroteOffOrNot: 'writtenoff or not',
  billingCharge_generatedBillsOrNot: 'bills issued or not',
  billingCharge_invoicedOrNot: 'invoice issued or not',
  billingCharge_appliedForPaymentOrNot: 'withdrawal requested or not',
  billingCharge_drawABbillOrNot: 'invoices required or not',
  billingCharge_department: 'Department',
  billingCharge_contactPerson: 'Contact Person',
  billingCharge_settlementType: '決済種別',
  billingCharge_invoicingMethod: '請求方式',
  billingCharge_accrued: '未払計上',
  billingCharge_receivablesInvoicingStatus: '売掛請求書ステータス',
  billingCharge_bookingNo: ' ブッキング番号',
  billingCharge_unitPrice: '単価',
  billingCharge_invoiceHeader: 'invoice title',
  billingCharge_businessReferenceNumber: 'Job reference number',
  billingCharge_warehouseNo: 'warehouse in no',
  billingCharge_vesselAndVoyage: 'vessel/voyage no',
  billingCharge_portOfLoading: 'Port Of Loading',
  billingCharge_portOfDestination: 'Port Of Destination',
  billingCharge_financialDate: '会計処理日',
  billingCharge_domesticOrInternational: 'domestic and overseas',
  billingCharge_paymentType: 'Payment Type',
  billingCharge_amount: 'Amount',
  billingCharge_taxIncludedPrice: 'taxInclusivePrice',
  billingCharge_taxExcludedPrice: 'taxExclusivePrice',
  billingCharge_taxAmount: '消費税額',
  billingCharge_theAmountOfWriteOffs: 'Clearance Amount',
  billingCharge_amountNotWrittenOff: 'Amount Not Clearance',
  billingCharge_reconciliationAmount: '精算差額金額',
  billingCharge_difference: '差異金額（差額）',
  billingCharge_confirmationRemarks: 'Confirmation Remarks',
  billingCharge_confirmState: '承認ステータス（経理確認）',
  billingCharge_creator: '作成者',
  billingCharge_dateCreated: 'Date Created',
  billingCharge_remarks: '備考',

  billingJob_businessNumber: 'JobNumber',
  billingJob_consignationCompany: 'Consignation Company',
  billingJob_settlementCompany: 'Settlement Company',
  billingJob_mblNo: 'MasterB/L',
  billingJob_vessel: 'MotherVessel',
  billingJob_voyage: 'VoyageNumber',
  billingJob_carrier: 'Carrier',
  billingJob_billNo: '請求番号',
  billingJob_invoiceNo: 'インボイス番号',
  billingJob_itemNo: 'ReferenceNumber',
  billingJob_businessType: 'ShippingType',
  billingJob_soNo: 'SO NO',
  billingJob_businessStatus: '配送ステータス',
  billingJob_solicitationType: 'Source of Freight',
  billingJob_chargeItem: 'Designation of charges',
  billingJob_feeStatus: '支払ステータス',
  billingJob_confirmStatus: '確認ステータス',
  billingJob_businessDate: 'JobDate',
  billingJob_amountRange: '金額帯',
  billingJob_receivablesInvoicingDate: 'Receivables Invoicing Date',
  billingJob_currency: ' 通貨',
  billingJob_operation: ' 操作内容',
  billingJob_sales: ' 売上',
  billingJob_advanceMoneyForAnotherOrNot: 'disbursement or not',
  billingJob_adjustedOrNot: 'adjust or not',
  billingJob_wroteOffOrNot: 'writtenoff or not',
  billingJob_generatedBillsOrNot: 'bills issued or not',
  billingJob_invoicedOrNot: 'invoice issued or not',
  billingJob_appliedForPaymentOrNot: 'withdrawal requested or not',
  billingJob_drawABbillOrNot: 'invoices required or not',
  billingJob_department: 'Department',
  billingJob_contactPerson: 'Contact Person',
  billingJob_settlementType: '決済種別',
  billingJob_invoicingMethod: '請求方式',
  billingJob_accrued: '未払計上',
  billingJob_receivablesInvoicingStatus: '売掛請求書ステータス',
  billingJob_bookingNo: ' ブッキング番号',
  billingJob_unitPrice: '単価',
  billingJob_invoiceHeader: 'invoice title',
  billingJob_businessReferenceNumber: 'Job reference number',
  billingJob_warehouseNo: 'warehouse in no',
  billingJob_vesselAndVoyage: 'vessel/voyage no',
  billingJob_portOfLoading: 'Port Of Loading',
  billingJob_portOfDestination: 'Port Of Destination',
  billingJob_financialDate: '会計処理日',
  billingJob_domesticOrInternational: 'domestic and overseas',
  billingJob_paymentType: 'Payment Type',
  billingJob_amount: 'Amount',
  billingJob_taxIncludedPrice: 'taxInclusivePrice',
  billingJob_taxExcludedPrice: 'taxExclusivePrice',
  billingJob_taxAmount: '消費税額',
  billingJob_theAmountOfWriteOffs: 'Clearance Amount',
  billingJob_amountNotWrittenOff: 'Amount Not Clearance',
  billingJob_reconciliationAmount: '精算差額金額',
  billingJob_difference: 'Difference',
  billingJob_confirmationRemarks: 'Confirmation Remarks',
  billingJob_ReviewRemarks: '審査備考',
  InquiryLetterRemark: '照会書備考',
  WarmPromptAppend: 'ご注意：入力された備考は元の財務備考情報の後ろに追加されます',
  WarmPromptOverwrite: 'ご注意：入力された備考は元の照会書備考情報を上書きします',
  billingJob_confirmState: '承認ステータス（経理確認）',
  billingJob_creator: '作成者',
  billingJob_dateCreated: 'Date Created',
  billingJob_remarks: '備考',
  billingJob_customerLevel: '顧客ランク',
  billingJob_settlementMethod: '決済方法',
  billingJob_chargesContactPerson: 'Charges Contact Person',
  billingJob_confirmUser: '確認者',
  // billingJob_settlementType: '決済種別',
  // billingJob_invoiceHeader: 'invoice title',
  billingJob_settleAccountsTo: '決済対象',
  billingJob_otherPartyBilling: '他勘定明細番号',
  billingJob_customer: 'Customer',
  billingJob_portOfDischarge: 'Port of Discharge',
  billingJob_dateOfDeparture: 'Date Of Departure',
  billingJob_bookingAgent: 'Booking Agent',
  billingJob_revenueAndExpenditureType: 'Type',
  billingJob_chargesTotalAmount: 'Charges Total Amount',
  billingJob_dateOfArrival: 'Date Of Arrival',
  billingJob_billDate: '伝票日付',
  billingJob_invoiceDate: '請求日',
  billingJob_originalCurrency: 'Original Currency',
  billingJob_billAndCurrency: 'Bill Currency',
  billing_billAmount: 'Bill Amount',
  billingJob_operationDepartment: 'Operation Department',
  billingJob_generatedAccountStatement: 'Generated Account Statement Or Not',
  billingJob_wroteOff: 'Wrote Off Or Not',
  billingJob_aging: 'Aging(days)',
  billingJob_agentBillNo: 'Agent Bill No',
  billingJob_billStatus: 'Bill Status',
  billingJob_accountStatementNo: 'Account Statement No',
  billingJob_invoicingRequirements: 'Invoicing Requirements',
  billingJob_proofDate: 'Financial Vouchers Date',
  billingJob_customerService: 'カスタマーサービス',
  billingJob_invoicingStatus: 'Invoicing Status',
  billingJob_writeOffStatus: 'Write Off Status',
  billingJob_writeOffStatus_bill: 'Write Off Status',
  billingJob_writeOffStatus_reconciliation: 'Write Off Status',
  billingJob_amountOfMoney: 'Amount Of Money',
  billingJob_notInvoicedMoney: 'uninvoiced amount',
  billingJob_totalCurrency: 'TotalByCurrency',
  billingJob_totalAmountNotWrittenOff: 'Total Amount Not Clearance',
  billingJob_taxRate: '税率',
  billingJob_customJobType: 'Customized Job Type',
  billingJob_voyageLine: '航路',
  billingJob_separateNumber: 'House B/L Number',
  billingJob_dateTo: 'To',
  billingJob_lockCheckBoxDate: 'Query Data For Only Two Years',
  billingJob_inputDateNotEmpty: 'InputDate Not Empty',
  billingJob_unlockInputDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  billingJob_billPaymentDate: 'withdrawal requested date',
  billingJob_billPaymentDateNotEmpty: 'withdrawal requested date not empty',
  billingJob_unlockBillPaymentDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  billingJob_userDefinedField1: 'UserDefinedField1',
  billingJob_userDefinedField2: 'UserDefinedField2',
  billingJob_userDefinedField3: 'UserDefinedField3',
  billingJob_userDefinedField4: 'UserDefinedField4',
  billingJob_markDate: 'MarkDate',
  billingJob_markUser: 'MarkUser',
  billingJob_markStatus: 'MarkStatus',
  billingJob_mark: 'Mark',
  billingJob_vesselAndVoyageAndFlight: 'Vessel Voyage Flight',
  billingJob_billPaymentOrNot: 'BillPayment Or Not',
  billingJob_voyageAndFlight: 'Voyage And Flight',
  billingJob_containerDescription: 'FinalCommodityDescription',
  billingJob_InputDate: '明細書作成日',

  billingView_total: '合計',
  billingView_query: 'Query',
  billingView_newAccountStatement: 'New Account Statement',
  billingView_edit: 'Edit',
  billingView_delete: 'Delete',
  billingView_view: 'View',
  billingView_confirm: 'Confirm',
  billingView_cancelConfirmation: 'cancelConfirmation',
  billingView_print: 'Print',
  billingView_drawCollectInvoice: 'Draw/Collect invoice',
  billingView_writeOff: 'Write-Off',
  billingView_applyForPayment: 'Request withdraw',
  billingView_revenueAndExpenditureMethod: '収支方式',
  billingView_receivables: 'Receivables',
  billingView_payables: 'Payables',
  billingView_all: 'ALL',
  billingView_billType: 'Bill Type',
  billingView_domestic: 'Domestic',
  billingView_international: 'Overseas',
  billingView_reconciliationType: 'Reconciliation type',
  billingView_accordingToBusiness: 'According to business',
  billingView_accordingToCharges: 'accordingto fees and charges',

  billingForm_taxAmount: '消費税額',
  billingForm_taxFreeAmount: 'Tax Free Amount',
  billingForm_bankOfDeposit: 'Bank Of Deposit',
  billingForm_bankAccount: 'Bank Account',
  billingForm_collectAndPrepaidOrNot: 'Collect or Prepaid',
  billingForm_unit: ' 単位',

  billingAccount_accountStatementType: 'Account Statement Type',
  billingAccount_writeOffOrNot: 'Write-Off or not',
  billingAccount_invoicingInformation: 'Invoicing Information',

  billingGroup_dateOfFiling: 'InvoiceDate',
  billingGroup_settleAccountsTo: '決済対象',
  billingGroup_invoicingAddress: 'Invoicing Address',
  billingGroup_addBill: 'Add Bill',
  billingGroup_deleteBill: 'Delete Bill',
  billingGroup_previous: 'Previous',
  billingGroup_next: 'Next',
  billingJob_settlementAgent: 'Settlement Agent',
  billingJob_billingCreator: 'Billing Creator',

  Query: 'Query',
  View: 'View',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  print: 'Print',
  statistics: 'Statistics',
  ExportAllExcel: 'Export all Excel',
  BusinessNo: 'Job Number',
  WarehouseNo: 'warehouse in no',
  WayBillNumber: 'BillofLadingNumber',
  Destination: 'Destination',
  PortOfDestination: 'Port of Dest',
  WarehouseEntryTime: 'StorageTime',
  DeliveryTime: 'Delivery Time',
  DataEntryClerk: 'Inputer',
  Dataentryclerk: 'Inputer',
  NumberOfCases: 'NumberOfPackages',
  Weight: 'Weight',
  Volume: 'Volume',
  ComputationIsAffectedByDampness: 'DamagedMoisture',
  IntoTheWarehousePhotos: 'IntoTheWarehousePhotos',
  WarehouseName: 'WarehouseName',
  Warehouseman: 'WarehouseClerk',
  StorageLocation: 'Storage Location',
  Receiptnumber: 'Receipt Number',
  BlNo: 'B/LNo',
  UploadFile: 'Upload File',
  batchdownload: 'Batch Download',
  ResetFilter: 'ResetFilter',
  billingCharge_billingGroupNo: '請求グループ番号',
  modifiedBy: 'Modified By',
  dateModified: 'Date Modified',

  invoiceHeader: '請求書ヘッダー名',
  revenueOrExpenditure: 'RevenueOrExpenditure',
  InvoicingAmount: 'InvoicingAmount',
  invoicingExchangeRate: 'InvoicingExchangeRate',
  invoiceInformation: 'InvoiceInformation',
  LoadingPort: 'LoadingPort',
  seaportOfDischarge: 'Port of Discharge(seaport)',
  billingJob_confirmDate: 'Billing Confirm Time',
  billingJob_theAmountOfNotWriteOffs: 'Amount Not Clearance',
  QueryAgencyShareBill: 'Query Agency Share Bill',
  ForceDeleteBilling: '{0} bill {1} cannot be deleted forcibly.',
  HasBillPayment: 'Paid application',
  HasBillingGroup: 'Statement created',
  HasWriteOff: 'Written off',
  HasClosingAccount: 'Closed account',
  OppositeBillNoAlreadyExists: '<strong>Opposite bill No</strong> already exists, continue?',
  DueDate: '請求期限日',
  DueDateDirty: '請求期限',
  InCalculation: 'In calculation',
  NotCalculated: 'Not calculated',
  Calculated: 'Calculated',
  CancelConfirmedBillSameTime: 'Cancel the confirmed bill at the same time?',
  BillingConfirmStatus: 'Billing 確認ステータス',
  ApplyForInvoicing: 'Apply for invoicing',
  BillSettlementType: 'Bill settlement type',
  CostCannotExceed3Currencies: 'Cost cannot exceed 3 currencies',
  DomesticBill: 'Domestic bill',
  Currency: ' 通貨',
  CannotRemoveAllFees: 'Cannot remove all fees!',
  InvalidDate: '無効化日',
  Bill: 'Bill:',
  Billing_Requirements: 'Billing requirements',
  ForeignInvoiceTime: 'Foreign invoice issuance time'
}
